<app-filter-card
  i18n-heading
  heading="Kundenfilter"
  testId="customer-filter"
  [canReset]="isFiltered"
  (reset)="resetFilter()"
>
  <div class="col-12 col-md-3">
    <label for="customerFilterName" class="form-label" i18n>Name</label>
    <input
      id="customerFilterName"
      data-testid="customer-filter-name-input"
      class="form-control"
      type="text"
      [(ngModel)]="searchWord"
      (input)="searchThis()"
    />
  </div>

  <div class="col-12 col-md-3">
    <label for="customerFilterGroup" class="form-label" i18n>Kundengruppe</label>
    <kendo-dropdownlist
      id="customerFilterGroup"
      class="w-100"
      data-testid="customer-filter-group-dropdown"
      [data]="customerGroups"
      [defaultItem]="defaultItem"
      [(ngModel)]="customerGroupId"
      textField="name"
      valueField="id"
      [valuePrimitive]="true"
      (selectionChange)="customerGroupChange($event)"
    >
    </kendo-dropdownlist>
  </div>
</app-filter-card>
